// extracted by mini-css-extract-plugin
module.exports = {"button":"save-button-module--button--1GSTL","loading":"save-button-module--loading--jR5je"};